<template>
  <div class="financial-institution-selector">
    <el-select
      class="mb-4"
      :value="value"
      @input="handleChange"
      placeholder="เลือกสถาบันการเงิน"
    >
      <el-option
        v-for="f in financialInstitutions"
        :key="f.id"
        :label="f.name"
        :value="f.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: ["value", "financialInstitutions"],
  computed: {
    financialOptions() {
      if (!this.financialInstitutions) {
        return [];
      }

      return this.financialInstitutions;
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.financial-institution-selector {
  display: grid;
  grid-template-columns: 330px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/staff/components/FinancialInstitutionSelector.vue